/* eslint-disable @stylistic/js/max-len */
/* eslint-disable camelcase */
const widgetFaq = {
  faqConfig: {
    "es-es": {
      domainKey: {
        production:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0IjoiYmFyY2Vsb19ob3RlbF9ncm91cF9rbV9lcyIsImRvbWFpbl9rZXlfaWQiOiJCZU9PQlBjdkVCSUlpLUpMWU5fVmVROjoifQ.aJDrNhVcwiuOSwCXqRSnDWpctQ9FaH7ezfZmUnVSIoObqfuECggS9V-VBdWyB3rj3WSfAIe3ghRHKjFhfNkomw",
        development:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0IjoiYmFyY2Vsb19ob3RlbF9ncm91cF9rbV9lcyIsImRvbWFpbl9rZXlfaWQiOiJCZDljLThnZjE3ejFjNEp0YTVFQ3N3OjoifQ.EuN2dhfAyt9tHZGTJyvwwBkN88TrgCYi31918e0nlZ4snpUAjEcNjYLilYkCFvcZU7Y1bv2P_wLDEanQUUhTRg",
      },
      apiKey: {
        production: "BcVdj88C6GGkJjEdXV/NV/tq+ZrIi1T0hZsmbhf1TSs=",
        development: "BcVdj88sFM7HWLLBE0Ghc1reWxAFEda1BJBvbVtDySk=",
      },
      environment: {
        production: "production",
        development: "development",
      },
      labels: {
        SEARCH_BOX_PLACEHOLDER: "Puedes escribir aquí tu pregunta.",
        RESULTS_NOT_FOUND_TITLE: "",
        RESULTS_NOT_FOUND_TEXT: "No he encontrado información sobre",
        RESULTS_TEXT: "Éstos son los resultados para:",
        CATEGORIES_TITLE: "Categorías",
        RATINGS_GRETTINGS_TEXT: "¡Gracias!",
        CATEGORIES_BACK_BUTTON: "Volver",
        RATINGS_INTRODUCTION: "¿Has encontrado lo que buscabas?",
      },
      elements: {
        final_messageThanks: "¡Gracias!",
        final_messageCallme: "Lo lamento. Aquí tienes nuestro número de teléfono, llámanos y lo resolveremos. <br> <br> 📞 +34 971 92 80 21",
      },
    },
    "es-mx": {
      domainKey: {
        production:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0IjoiY2xuX2JhcmNlbG9faG90ZWxfZ3JvdXBlc19teF8xNjhlX2ttX2VzIiwiZG9tYWluX2tleV9pZCI6IkJldWxpX3U1czcxbE9hMmNIREdvVHc6OiJ9.RpNiGJPLFF9gut3N9LkKAt3AxzAGwstyPgScdm15h5FiA2uEuvK2PRBD-d4wYmBpKu4Q5Wlk8epdRLv2PTUnyA",
        development:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0IjoiY2xuX2JhcmNlbG9faG90ZWxfZ3JvdXBlc19teF8xNjhlX2ttX2VzIiwiZG9tYWluX2tleV9pZCI6IkJldWxrOU05V2p5MDkyS1V0R090cXc6OiJ9.cKcXAQVyk8AY7R09n-dzaPfXAv6OK0mToSNTSXxJy3yhdbW0JpHJNPXZ0SlDzCVxZ9UDjGc-14Uy75Ari8u3iA",
      },
      apiKey: {
        production: "BegCSwhRvzn2o9o6F+9mfpSLjlI65BD4g4JnaYzmvM0=",
        development: "BegCSwjCO05gDay2WEQXEBC8GvMq+5VqYWa5S3nOCcM=",
      },
      environment: {
        production: "production",
        development: "development",
      },
      labels: {
        SEARCH_BOX_PLACEHOLDER: "Puedes escribir aquí tu pregunta.",
        RESULTS_NOT_FOUND_TITLE: "",
        RESULTS_NOT_FOUND_TEXT: "No he encontrado información sobre",
        RESULTS_TEXT: "Éstos son los resultados para:",
        CATEGORIES_TITLE: "Categorías",
        RATINGS_GRETTINGS_TEXT: "¡Gracias!",
        CATEGORIES_BACK_BUTTON: "Volver",
        RATINGS_INTRODUCTION: "¿Has encontrado lo que buscabas?",
      },
      elements: {
        final_messageThanks: "¡Gracias!",
        final_messageCallme: "Lo lamento. Aquí tienes nuestro número de teléfono, llámanos y lo resolveremos. <br> <br> 📞 +34 971 92 80 21",
      },
    },
    en: {
      domainKey: {
        production:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0IjoiYmFyY2Vsb19ob3RlbF9ncm91cF9rbV9lbiIsImRvbWFpbl9rZXlfaWQiOiJCZXVsZndMMU5oSDBtTXJyRnlMRnJ3OjoifQ.iD50-zmbe9A3M1jSwYdrO1cxvJwCntWxnWF6vITJk3OtCh3guRDEbARleb4W2vWCIcxTZNyyTgiwZUvY1Z5kkw",
        development:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0IjoiYmFyY2Vsb19ob3RlbF9ncm91cF9rbV9lbiIsImRvbWFpbl9rZXlfaWQiOiJCZXVsaE1IUTdHTWhhMlQzM1RBMEZROjoifQ.WNr706A-S1PM2INiUQCs5fK7I4jX5dOKPz3HrWEmSajmeSc5aOu59UpZlm2zGe94BrgrwfdAYbTtXPq-1o6I7g",
      },
      apiKey: {
        production: "BegCPgx8Vhn/OXudDDgaKMr0Vrj2fuGh1JvkSyzvgE4=",
        development: "BegCPgype8bNIXmbpQfmsNXtt/tnRaZbv/zFFb/u/ko=",
      },
      environment: {
        production: "production",
        development: "development",
      },
      labels: {
        SEARCH_BOX_PLACEHOLDER: "You can write your question here.",
        RESULTS_NOT_FOUND_TITLE: "",
        RESULTS_NOT_FOUND_TEXT: "I have not found information about",
        RESULTS_TEXT: "These are the results for:",
        CATEGORIES_TITLE: "Categories",
        RATINGS_GRETTINGS_TEXT: "Thank you!",
        CATEGORIES_BACK_BUTTON: "Return",
        RATINGS_INTRODUCTION: "Have you found what you were looking for?",
      },
      elements: {
        final_messageThanks: "Thank you!",
        final_messageCallme: "I'm sorry. Here's our phone number, give us a call and we'll sort it out. <br> <br> 📞 +34 971 92 80 21",
      },
    },
  },
  init: function () {
    // Para entorno productivo descomentar esta linea
    // const config = getConfigBySiteURL('production').chatbot;

    // Para entorno productivo comentar esta linea
    const config = this.getConfigBySiteURL("production").faq;
    // eslint-disable-next-line no-undef
    const sdk = InbentaKmSDK.createFromDomainKey(config.domainKey, config.apiKey, config);
    const searchBox = sdk.component("searchBox", "#search-box");
    const results = sdk.component("results", "#results", {
      contents: {
        ratings: {
          labels: {
            RATINGS_INTRODUCTION: config.labels["RATINGS_INTRODUCTION"],
          },
          elements: [
            {
              id: 1,
              label: "Yes",
              comment: false,
              final_message: config.elements["final_messageThanks"],
            },
            {
              id: 2,
              label: "No",
              comment: false,
              final_message: config.elements["final_messageCallme"],
            },
          ],
        },
      },
    });
    const autocompleter = sdk.component("autocompleter", "#autocompleter");
    autocompleter.linkToSearchBox(searchBox);
    results.linkToAutocompleter(autocompleter);
    results.linkToSearchBox(searchBox);

    const categories = sdk.component("categories", "#categories", {
      length: 10,
      categoriesGroupLength: 2,
      contents: {
        ratings: {
          labels: {
            RATINGS_INTRODUCTION: config.labels["RATINGS_INTRODUCTION"],
          },
          elements: [
            {
              id: 1,
              label: "Yes",
              comment: false,
              final_message: config.elements["final_messageThanks"],
            },
            {
              id: 2,
              label: "No",
              comment: false,
              final_message: config.elements["final_messageCallme"],
            },
          ],
        },
      },
    });
    const categoriesPromise = async () => {
      await categories.setCategoriesDataInterceptor((categories) => {
        // 68: "/content/dam/barcelo/commons/icons/ui/spa_black.svg",
        const categoryImages = {
          3: "/content/dam/barcelo/commons/icons/ui/info_black.svg",
          5: "/content/dam/barcelo/commons/icons/ui/spa_black.svg",
          11: "/content/dam/barcelo/commons/icons/ui/calendar_black.svg",
          14: "/content/dam/barcelo/commons/icons/ui/building_black.svg",
          20: "/content/dam/barcelo/commons/icons/ui/room-service_black.svg",
          22: "/content/dam/barcelo/commons/icons/ui/myb_black.svg",
          93: "/content/dam/barcelo/commons/icons/ui/pro_black.svg",
          107: "/content/dam/barcelo/commons/icons/ui/discount-code_black.svg",
        };

        for (let i = 0; i < categories.length; i++) {
          const originalName = categories[i]["name"];
          categoryImages[categories[i].id] != undefined
            ? (categories[i]["name"] = '<span class="title__icon"> <img class="categoryIcon" loading="lazy" width="500" height="250" src="' + categoryImages[categories[i].id] + '"></img> </span>')
            : (categories[i]["name"] = "");
          categories[i]["name"] += '<span class="category_title">' + originalName + "</span>";
          categories[i]["name"] += '<span class="title__icon"> <img class="categoryRightArrow" src="/content/dam/barcelo/commons/icons/ui/arrow_right.svg" loading="lazy" width="500" height="250"></img> </span>';
        }
        return Promise.resolve(categories);
      });
    };
    categoriesPromise();
  },
  getConfigBySiteURL: function (environment = "development") {
    const config = {
      faq: {},
    };
    if (window.location.href.indexOf("es-mx") !== -1) {
      config.faq = {
        domainKey: this.faqConfig["es-mx"].domainKey[environment],
        apiKey: this.faqConfig["es-mx"].apiKey[environment],
        environment: this.faqConfig["es-mx"].environment[environment],
        labels: this.faqConfig["es-mx"].labels,
        elements: this.faqConfig["es-mx"].elements,
      };
    } else if (window.location.href.indexOf("en-") !== -1) {
      config.faq = {
        domainKey: this.faqConfig["en"].domainKey[environment],
        apiKey: this.faqConfig["en"].apiKey[environment],
        environment: this.faqConfig["en"].environment[environment],
        labels: this.faqConfig["en"].labels,
        elements: this.faqConfig["en"].elements,
      };
    } else {
      config.faq = {
        domainKey: this.faqConfig["es-es"].domainKey[environment],
        apiKey: this.faqConfig["es-es"].apiKey[environment],
        environment: this.faqConfig["es-es"].environment[environment],
        labels: this.faqConfig["es-es"].labels,
        elements: this.faqConfig["es-es"].elements,
      };
    }
    config.faq.source = "FAQ";
    return config;
  },
};
export default widgetFaq;
